import { RefObject, useCallback } from 'react';
import toast from '@/config/react-toast'

type Props = {
  min?: number | string;
  max?: number | string;
  inputRef?: RefObject<HTMLInputElement>;
  toastConfig?: {
    message: string;
    type?: 'error' | 'success';
    id?: string;
  };
  onChange?: (event: FocusEvent) => void;
}

const useMinMaxValidations = ({ min: minValue, max: maxValue, toastConfig, onChange }: Props) => {
  
  const handleOnBlur = useCallback((event: FocusEvent) => {
    const target = event.target as HTMLInputElement;
    const targetValue = target.value;
    const value = Number(targetValue);
    
    const min = Number(minValue);
    const max = Number(maxValue);

    let isValueManipulated = false;

    if (!isNaN(min) && !isNaN(max) && min > max) {
      return;
    }

    if (!isNaN(min) && value < min) {
      target.value = min?.toString() || '';
      isValueManipulated = true;
    }
    
    if (!isNaN(max) && value > max) {
      target.value = max?.toString() || '';
      isValueManipulated = true;
    }

    if (isValueManipulated) {
      if (toastConfig && toastConfig.message) {
        toast(toastConfig.message, { type: toastConfig.type || 'error', id: toastConfig.id });
      }
      if (onChange) {
        const syntheticOnChangeEvent = Object.assign(event, {
          type: 'change',
        }) as unknown as FocusEvent;

        onChange(syntheticOnChangeEvent);
      }
    }
  }, [minValue, maxValue]);
  
  return { handleOnBlur };
};

export default useMinMaxValidations;